module.exports = __webpack_public_path__ + "img/mob1.c58b67ad.png";